<template>
    <div class="Crisis_statistics">
        <div class="Crisis_statistics_top">
            <h2>总体统计(人次)</h2>
            <div class="censusfix">
                <ul>
                    <li>
                        <h3>{{topdata.TotalQnty}}</h3>
                        <p>上报总数</p>
                    </li>
                    <li>
                        <h3>{{topdata.DailyQnty}}</h3>
                        <p>日常上报</p>
                    </li>
                    <li>
                        <h3>{{topdata.OwnQnty}}</h3>
                        <p>自主上报</p>
                    </li>
                    <li>
                        <h3>{{topdata.ConsultQnty}}</h3>
                        <p>咨询上报</p>
                    </li>
                    <li>
                        <h3>{{topdata.TestQnty}}</h3>
                        <p>测评上报</p>
                    </li>
                    <li>
                        <h3>{{topdata.HotlineQnty}}</h3>
                        <p>热线上报</p>
                    </li>
                </ul>
                <div class="right">
                    <el-button class="minbtn" size="mini" @click="querycensus(1)">近一个月</el-button>
                    <el-button class="minbtn" size="mini" @click="querycensus(3)">近三个月</el-button>
                    <el-button class="minbtn" size="mini" @click="querycensus(6)">近半年</el-button>
                    <el-button class="minbtn" size="mini" @click="querycensus(12)">近一年</el-button>
                    <el-date-picker value-format="yyyy-MM-dd" style="width: 290px;height: 32px;margin-left:20px" format="yyyy-MM-dd" class="datatime" v-model="censusDate" type="daterange"  range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期"></el-date-picker>
                    <el-button type="primary" style="margin-left:20px;" @click="czfun()">重置</el-button>
                </div>
            </div>
        </div>

        <!-- 统计模块 -->
        <div class="census">
            <div class="left"><div ref="Crisisreportecharts" style="width:98%;height: 340px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;"></div></div>
            <div class="right"><div ref="Crisisreportenum" style="width:98%;height: 340px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:20px"></div></div>
        </div>

        <div class="census">
            <div class="left"><div ref="Crisislevel" style="width:98%;height: 340px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;"></div></div>
            <div class="right"><div ref="Crisisreportenumsex" style="width:98%;height: 340px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:20px"></div></div>
        </div>

        <div class="Crisis_statistics_nav">
            <el-form style="padding: 15px;" :inline="true" class="demo-form-inline">
                <el-form-item label="姓名">
                    <el-input v-model="Name" placeholder="姓名"></el-input>
                </el-form-item>
                <el-form-item label="时间段">
                  <el-date-picker type="daterange"  value-format="yyyy-MM-dd" v-model="Dates" :range-separator="$t('original.languages296')" :start-placeholder="$t('original.languages346')" :end-placeholder="$t('original.languages347')" unlink-panels></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                    <el-button type="primary" @click="resetfun">重置</el-button>
                    <el-button type="primary" @click="derivefun">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="tableData" style="width: 100%;width: 98%;margin-left:1%"> 
                <el-table-column prop="realName"  label="上报人"></el-table-column>
                <el-table-column prop="consultQnty"  label="咨询上报"></el-table-column>
                <el-table-column prop="dailyQnty"  label="日常危机上报"></el-table-column>
                <el-table-column prop="hotlineQnty"  label="热线上报"></el-table-column>
                <el-table-column prop="ownQnty"  label="自主上报"></el-table-column>
                <el-table-column prop="testQnty"  label="测评上报"></el-table-column>
                <el-table-column prop="totalCounts"  label="上报总数"></el-table-column>
                <el-table-column label="操作">
                <template slot-scope="scope">
                    <span style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" @click="re_look(scope.row)">详情</span>
                </template>
                </el-table-column>
            </el-table>
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts"></el-pagination>
        </div>
        <el-drawer title="我是标题"  :visible.sync="drawer" size="40%" :with-header="false">
            <el-table :data="tableData2" style="width: 100%;width: 98%;margin-left:1%"> 
                <el-table-column prop="userID"  label="学号"></el-table-column>
                <el-table-column prop="realName"  label="姓名"></el-table-column>
                <el-table-column prop="type"  label="上报类型"></el-table-column>
                <el-table-column prop="recordTime"  label="上报时间"></el-table-column>
            </el-table>
            <el-pagination @current-change="handleCurrentChange2" :current-page.sync="pageIndex2" :page-size="10" layout="total, prev, pager, next" :total="Counts2"></el-pagination>
        </el-drawer>
    </div>
</template>
<script>
    export default{
        data() {
            return {
                drawer: false,
                topdata: [],
                tableData2: [],
                Name: '',
                pageIndex: 1,
                pageSize: 10,
                pageIndex2: 1,
                pageSize2: 10,
                tableData: [],
                Dates: [],
                Counts: 0,
                Counts2: 0,
                userID: '',
                // 统计
                censusparams:{
                    from:"2024-01-01",
                    to:"2024-06-30"
                },
                censusDate:this.Global.querycensus(6),
            }
        },
        watch:{
            censusDate(newval,oldeval){
                if(newval){
                    this.censusparams.from=newval[0];
                    this.censusparams.to=newval[1];
                }else{
                    this.censusparams.from="";
                    this.censusparams.to="";
                }
                this.crisisStatisticsB();
                this.getcrisisReportData();
                this.geteducStatis();
                this.getcrisisGradeData();
                this.getgenderStatis();
            }
        },
        mounted() {
            this.censusparams.from = this.Global.querycensus(6)[0]
            this.censusparams.to = this.Global.querycensus(6)[1]
            this.crisisStatisticsB();
            this.load();
            this.getcrisisReportData();
            this.geteducStatis();
            this.getcrisisGradeData();
            this.getgenderStatis();
        },
        methods: {
            czfun(){
                this.querycensus(6)
            },
            crisisStatisticsB(){
                this.$Http_Post('management/distressPrediction/crisisStatisticsB', this.censusparams).then((res) => {
                    if (res.Code == 200 || res.Code == 0) {
                        this.topdata = res.Data;
                    }else{
                        this.Global.request_failure(res.Message);
                    }
                });
            },
            re_look(row){
                this.userID = row.userID;
                this.loads2();
            },
            loads2(){
                this.$Http_Post('management/distressPrediction/crisisInfo', {                    
                    pageIndex:this.pageIndex2,
                    pageSize:this.pageSize2,
                    userID:this.userID
                }).then((res) => {
                    if (res.Code == 200 || res.Code == 0) {
                        this.tableData2 = res.Data;
                        this.Counts2 = res.Counts;
                        this.drawer = true;
                    }else{
                        this.Global.request_failure(res.Message);
                    }
                });
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.load();
            },
            handleCurrentChange2(val) {
                this.pageIndex2 = val;
                this.loads2();
            },
            onSubmit(){
                this.pageIndex = 1;
                this.load();
            },
            resetfun(){
                this.Dates = [];
                this.pageIndex = 1;
                this.Name = '';
                this.load();
            },
            derivefun(){
                var from = {
                    Name:this.Name,
                    pageIndex:this.pageIndex,
                    pageSize:this.pageSize,
                    DeriveText:'1',
                    Date:this.Dates,
                }
                this.$Http_Post('management/distressPrediction/crisisStatisticXb', {from:from}).then((res) => {
                    if (res.Code == 200 || res.Code == 0) {
                        window.location.href = res.Data;
                    }else{
                        this.Global.request_failure(res.Message)
                    }
                });
            },
            load(){
                var from = {
                    Name:this.Name,
                    pageIndex:this.pageIndex,
                    pageSize:this.pageSize,
                    DeriveText:'0',
                    Date:this.Dates,
                }
                this.$Http_Post('management/distressPrediction/crisisStatisticXb', {from:from}).then((res) => {
                    if (res.Code == 200 || res.Code == 0) {
                        this.tableData = res.Data;
                        this.Counts =  res.Counts;
                    }else{
                        this.Global.request_failure(res.Message);
                    }
                });
            },
            // 危机上报统计接口
            getcrisisReportData(){
                this.$Http_Post('/management/distressPrediction/crisisReportData',this.censusparams).then(res=>{
                    if(res.Code==0 || res.Code==200){
                        let AllcrisisReport={
                            month:[],
                            reportNum:[],
                            dailyNum:[],
                            ownNum:[],
                            consultNum:[],
                            testNum:[],
                            hotNum:[]
                        };
                        res.Data.result.forEach(item => {
                            Object.keys(AllcrisisReport).forEach(key => {
                                AllcrisisReport[key].push(item[key]);
                            });
                        });
                        this.$nextTick(() => {
                            this.peopleNumByDegree(AllcrisisReport);
                        });
                    }else{
                        this.Global.request_failure(res.Message); 
                    }
                })
            },
            // 危机等级统计接口
            getcrisisGradeData(){
                this.$Http_Post('/management/distressPrediction/crisisGradeData',this.censusparams).then(res=>{
                    if(res.Code==0 || res.Code==200){
                        var crisisGradeData = {
                            month: [],
                            redNum: [],
                            orangeNum: [],
                            yellowNum: [],
                            blueNum: [],
                            greenNum: []
                        };

                        res.Data.result.forEach(item => {
                            Object.keys(crisisGradeData).forEach(key => {
                                crisisGradeData[key].push(item[key]);
                            });
                        });
                        this.$nextTick(() => {
                            this.Crisislevel(crisisGradeData);
                        });
                    }else{
                        this.Global.request_failure(res.Message); 
                    }
                })
            },
            // 危机上报人数性别统计接口
            getgenderStatis(){
                this.$Http_Post('/management/distressPrediction/genderStatis',this.censusparams).then(res=>{
                    if(res.Code==0 || res.Code==200){
                        this.$nextTick(() => {
                            this.Crisisreportenumsex(res.Data);
                        });
                    }else{
                        this.Global.request_failure(res.Message); 
                    }
                })
            },
            // 危机上报学历统计接口
            geteducStatis(){
                this.$Http_Post('/management/distressPrediction/educStatis',this.censusparams).then(res=>{
                    if(res.Code==0 || res.Code==200){
                        this.educStatis=res.Data;
                        this.$nextTick(() => {
                            this.Crisisreportenum();
                        });
                    }else{
                        this.Global.request_failure(res.Message); 
                    }
                })
            },
            // 危机上报数据统计
            peopleNumByDegree(data) {
                var myChart = this.$echarts.init(this.$refs.Crisisreportecharts);
                var option = {
                    title: {
                        text: '危机上报数据(人次)',
                        left: '20px',
                        top: '10px',
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['上报总数','日常上报','自主上报','咨询上报','测评上报','热线上报'],
                        top: '10px',
                        left:'200px',
                    },
                    xAxis: {
                        type: 'category',
                        data:data.month
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name:'上报总数',
                            data: data.reportNum,
                            type: 'line',
                            smooth: true,
                            color: '#93C22D'  
                    
                        },
                        {
                            name:'日常上报',
                            data: data.dailyNum,
                            type: 'line',
                            smooth: true,
                            color: '#557CD9'  

                        },
                        {
                            name:'自主上报',
                            data: data.ownNum,
                            type: 'line',
                            smooth: true,
                            color: '#E3B540'  
                        },
                        {
                            name:'咨询上报',
                            data: data.consultNum,
                            type: 'line',
                            smooth: true,
                            color: '#FF5454'  
                        },
                        {
                            name:'测评上报',
                            data: data.testNum,
                            type: 'line',
                            smooth: true,
                            color: '#AC33C1'  
                        },{
                            name:'热线上报',
                            data: data.hotNum,
                            type: 'line',
                            smooth: true,
                            color: '#32BFC2'  
                        }
                    ]
                };
                myChart.setOption(option);
                window.addEventListener("resize", function () {
                    myChart.resize();
                });
            },
            Crisisreportenum(){
                var myChart = this.$echarts.init(this.$refs.Crisisreportenum);
                var option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{c}'  
                    },
                    color:['#FFB938', '#557CD9', '#93C22D'],
                    title: {
                        text: '危机上报人数(学历)',
                        left: '20px',
                        top: '10px',
                    },
                    legend: {
                        top: '90%',
                        left: 'center',
                        selectedMode: false
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['40%', '70%'],
                            data: [
                                { value: this.educStatis.benke, name: '本科',Percentage:this.educStatis.benkePercentage},
                                { value: this.educStatis.suosi, name: '硕士',Percentage:this.educStatis.suosiPercentage},
                                { value: this.educStatis.bosi,  name: '博士',Percentage:this.educStatis.bosiPercentage},
                            ],
                            tooltip: {  
                                formatter: function(params) {
                                    var res = '人数：'+params.data.value + '<br/> 占比：' + params.data.Percentage; 
                                    return res;  
                                }  
                            }  
                        }
                    ]
                };
                myChart.setOption(option);
                window.addEventListener("resize", function () {
                    myChart.resize();
                });
            },
            // 危机上报等级
            Crisislevel(data){
                var myChart = this.$echarts.init(this.$refs.Crisislevel);
                var option = {
                    title: {
                        text: '危机等级数据(人次)',
                        left: '20px',
                        top: '10px',
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['重度','较重','中度','轻度','良好'],
                        top: '10px',
                        left:'200px',
                    },
                    xAxis: {
                        type: 'category',
                        data:data.month
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name:'重度',
                            data: data.redNum,
                            type: 'line',
                            smooth: true,
                            color: '#D43030'  
                        },
                        {
                            name:'较重',
                            data: data.orangeNum,
                            type: 'line',
                            smooth: true,
                            color: '#FF5454'  
                        },
                        {
                            name:'中度',
                            data: data.yellowNum,
                            type: 'line',
                            smooth: true,
                            color: '#E3B540'  
                        },
                        {
                            name:'轻度',
                            data: data.blueNum,
                            type: 'line',
                            smooth: true,
                            color: '#557CD9'  
                        },
                        {
                            name:'良好',
                            data: data.greenNum,
                            type: 'line',
                            smooth: true,
                            color: '#9CC436'  
                        }
                    ]
                };
                myChart.setOption(option);
                window.addEventListener("resize", function () {
                    myChart.resize();
                });
            },
            // 危机上报人数性别
            Crisisreportenumsex(data){
                var myChart = this.$echarts.init(this.$refs.Crisisreportenumsex);
                var option = {
                    title: {
                        text: '危机上报人数(性别)',
                        left: '20px',
                        top: '10px',
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter:function(params){
                            return params.name+'<br/>人数：'+params.data.value + '<br/> 占比：' + params.data.Percentage;
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: ['男', '女']
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [
                            {value: data.boy,  itemStyle: {color: '#557CD9',smooth: true},Percentage:data.boyPercentage},
                            {value: data.girl, itemStyle: {color: '#93C22D',smooth: true},Percentage:data.girlPercentage},
                        ],
                        type: 'bar',
                        barWidth: 30
                    }]
                };
                // var option = {
                //     tooltip: {
                //         trigger: 'item',
                //         formatter: '{a} <br/>{c}'  
                //     },
                //     color:['#557CD9','#93C22D', '#FFC851'],
                //     title: {
                //         text: '危机上报人数性别占比',
                //         left: '20px',
                //         top: '10px',
                //     },
                //     legend: {
                //         top: '90%',
                //         left: 'center',
                //         selectedMode: false
                //     },
                //     series: [
                //         {
                //             type: 'pie',
                //             radius: ['40%', '70%'],
                //             data: [
                //                 { value: data.girl, name: '女',Percentage:data.girlPercentage},
                //                 { value: data.boy, name: '男' ,Percentage:data.boyPercentage}
                //             ],
                //             tooltip: {  
                //                 formatter: function(params) {
                //                     var res = '人数：'+params.data.value + '<br/> 占比：' + params.data.Percentage; 
                //                     return res;  
                //                 }  
                //             }  
                //         }
                //     ]
                // };
                myChart.setOption(option);
                window.addEventListener("resize", function () {
                    myChart.resize();
                });
            },
            //根据选项查询 
            querycensus(data){
                this.censusDate = this.Global.querycensus(data);
                this.censusparams.from = this.censusDate[0];
                this.censusparams.to = this.censusDate[1];
            },
        },
    }
</script>
<style>
.Crisis_statistics{height: 100%;}
.Crisis_statistics .Crisis_statistics_top {height: 150px;background-color: #fff;}
.Crisis_statistics .Crisis_statistics_top .censusfix{display: flex;justify-content: space-between;}
.Crisis_statistics .Crisis_statistics_top ul::after{content: '';clear: both;display:block;}
.Crisis_statistics .Crisis_statistics_top ul{display: block;width: -webkit-fill-available;min-width: 600px;}
.Crisis_statistics .Crisis_statistics_top li{float: left;margin-left: 3%;}
.Crisis_statistics .Crisis_statistics_top h2{padding: 14px;}
.Crisis_statistics .Crisis_statistics_top li p{margin-left: 20px;margin-top: 10px;}
.Crisis_statistics .Crisis_statistics_top li h3{margin-left: 20px;font-size: 24px;color: rgba(0, 136, 255, 1);padding-top: 10px;}
.Crisis_statistics .Crisis_statistics_nav {height: calc(100% - 405px);margin-top: 15px;background-color: #fff;overflow: auto;}
.Crisis_statistics .census{margin:20px 0;display: flex;justify-content: space-between;}
.Crisis_statistics .census .left{width: calc(100% - 415px);background: #fff;}
.Crisis_statistics .census .right{background: #fff;width: 400px;}
.Crisis_statistics .minbtn{height: 32px!important;padding: 0px;width: 72px;}
.Crisis_statistics .datatime{width: 220px;height: 32px;margin-top:10px}
.Crisis_statistics .el-date-editor .el-range__icon,
.Crisis_statistics .el-date-editor .el-range-separator,
.Crisis_statistics .el-date-editor .el-range__close-icon{line-height: 24px;}
</style>